import {clearFeedbacksByName, getInputsByName} from "../../helpers/forms";
import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initTwoFactorAuthentication() {
	const fields = [
		'two_factor_authentication_password',
	];

	// Setup events
	document.querySelector('.two-factor-authentication-password-button')
		.addEventListener('click', () => {
			handleTwoFactorAuthenticationRequest();
		})


	document.querySelector('.cancel-two-factor-authentication-password-button')
		.addEventListener('click', () => {
			handleCancelTwoFactorAuthenticationRequest();
		})


	/**
	 * Methods
	 */

	function handleTwoFactorAuthenticationRequest() {
		clearFeedbacksByName(document.body, fields);

		const data = getInputsByName(document.body, fields);

		loading()
		Axios.post(window['routes/client.auth.submit-two-factor-authentication'], data)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading);
	}

	function handleCancelTwoFactorAuthenticationRequest() {
		loading()
		Axios.post(window['routes/logout'])
			.then(() => {
				// Skip usual SWAL popup
				window.location = window['routes/login'];
			})
			.catch(handleAjaxError)
	}
}

export {initTwoFactorAuthentication}
